import type { Router } from 'vue-router';
import { createRouteGuard } from './route';
import { createProgressGuard } from './progress';
import { createDocumentTitleGuard } from './title';

/**
 * 创建路由守卫
 *
 * @param router - 路由实例
 */
export function createRouterGuard(router: Router) {
  // 创建进度条守卫
  createProgressGuard(router);
  // 创建路由守卫
  createRouteGuard(router);
  // 后置路由守卫：主要用于在路由跳转后修改页面标题
  createDocumentTitleGuard(router);
}
